import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { MathEssentialProductAPIStat } from '~/redux/apis/user-stats-api'

import ProductCardContainer from '../ProductCardContainer'

import Details from './Details'
import Summary from './Summary'

export default function MathEssentialCard({ product }: { product: MathEssentialProductAPIStat }): React.ReactElement {
  const { t } = useTranslation('statistics')
  const [showContent, setShowContent] = useState(false)

  const cardName = `${t('math_essential')} - ${product.subject}`

  console.log('Math essential card name:', cardName)
  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <Summary onClick={onToogle} product={product} showContent={showContent} />
      {showContent && <Details product={product} />}
    </ProductCardContainer>
  )
}
